/** Detecta plazos en ES / EN / ZH y los devuelve como fragmentos para chips. */
const DEADLINE_REGEX =
  /(\d+\s*[-]?\s*(?:weeks?|semanas?|周|星期)|\d+\s*(?:días?|days?|天|日)|\d+\s*(?:horas?|hours?|小时|小時)|\d+\s*%)/gi;

export const classifyDeadline = (match) => {
  const m = match.toLowerCase();
  if (m.includes("%")) return "percent";
  if (/week|semana|周|星期/.test(m)) return "weeks";
  if (/hora|hour|小时|小時/.test(m)) return "hours";
  return "days";
};

export const splitTextWithDeadlines = (text) => {
  if (!text || typeof text !== "string") return [{ type: "text", value: text }];

  const parts = [];
  let lastIndex = 0;
  let match;

  const re = new RegExp(DEADLINE_REGEX.source, DEADLINE_REGEX.flags);
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: "text", value: text.slice(lastIndex, match.index) });
    }
    parts.push({
      type: "deadline",
      value: match[0].trim(),
      deadlineType: classifyDeadline(match[0]),
    });
    lastIndex = re.lastIndex;
  }

  if (lastIndex < text.length) {
    parts.push({ type: "text", value: text.slice(lastIndex) });
  }

  return parts.length ? parts : [{ type: "text", value: text }];
};

export const DEADLINE_CHIP_PALETTE = {
  hours: { main: "#1565c0", bg: "rgba(21, 101, 192, 0.1)" },
  days: { main: "#c05621", bg: "rgba(192, 86, 33, 0.12)" },
  weeks: { main: "#6b46c1", bg: "rgba(107, 70, 193, 0.12)" },
  percent: { main: "#2f855a", bg: "rgba(47, 133, 90, 0.12)" },
};
